import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { BillingSection } from '../../types/billing';
export type SidebarLink = {
  label: string;
  onClick: () => void;
  active?: boolean;
  disabled?: boolean;
  count?: number;
};
export type SidebarPanel = {
  id: string;
  label: string;
  links: SidebarLink[];
  sections: BillingSection[];
};
type Props = {
  panels: SidebarPanel[];
  current: BillingSection;
};

/** Express-Invoice-style accordion: grey panel bars that expand to show their actions. */
export function BillingSidebar({
  panels,
  current
}: Props) {
  const [open, setOpen] = useState<string[]>(() => panels.filter(p => p.sections.includes(current)).map(p => p.id));
  const toggle = (id: string) => setOpen(o => o.includes(id) ? o.filter(x => x !== id) : [...o, id]);
  return <nav aria-label="Billing navigation" className="space-y-2.5" data-id="element-3042" data-mp="3ho82oairvmjv">
      {panels.map(p => {
      const expanded = open.includes(p.id);
      return <div key={p.id} className="overflow-hidden rounded-[3px] border border-[#a9adb1] bg-[#d9dcdf]" data-id="element-3043" data-mp="3ls5z2dgpqj98">
            <button type="button" onClick={() => toggle(p.id)} aria-expanded={expanded} aria-controls={`bs-${p.id}`} className="flex h-8 w-full items-center justify-between px-2 text-left text-[12px] font-medium text-[#1f4fb5] hover:bg-[#e4e6e8] focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-[#1f4fb5]" data-id="element-3044" data-mp="efljbfu8qd5y">
              {p.label}
              <span className="flex h-[18px] w-[18px] items-center justify-center rounded-full border border-[#8b97a8] bg-white" data-id="element-3045" data-mp="3muna30hnol4n">
                <ChevronDownIcon className={`h-3 w-3 text-[#2d4f8f] transition-transform duration-200 ease-out ${expanded ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-3046" data-mp="5f6ysip3p23i" />
              </span>
            </button>
            {expanded && <ul id={`bs-${p.id}`} className="border-t border-[#b9bdc1] bg-white" data-id="element-3047" data-mp="343cl4ovhqife">
                  {p.links.map(l => <li key={l.label} data-id="element-3048" data-mp="3tq6rt85bu0v7">
                      <button type="button" onClick={l.onClick} disabled={l.disabled} aria-current={l.active ? 'page' : undefined} className={`flex w-full items-center px-3 py-1.5 text-left text-[12px] hover:bg-[#e8f0fb] hover:text-[#1f4fb5] disabled:cursor-not-allowed disabled:text-slate-400 disabled:hover:bg-transparent ${l.active ? 'bg-[#dbe7f8] font-semibold text-[#1f4fb5]' : 'text-slate-800'}`} data-id="element-3049" data-mp="3tpfa918ke3nx">
                        <span className="truncate" data-id="element-3050" data-mp="3jssn25srn0iq">{l.label}</span>
                        {!!l.count && <span className="ml-auto rounded-full bg-[#1f4fb5] px-1.5 text-[10px] font-bold tabular-nums text-white" data-id="element-3051" data-mp="3osoihgnedjmo">{l.count}</span>}
                      </button>
                    </li>)}
                </ul>}
          </div>;
    })}
    </nav>;
}